export default __webpack_public_path__ + "static/portfolio-l6-img-2-5869e022397b9a07fe724a533565185c.png";